import { useProcessActions } from '@hooks/useProcessActions';
import { FormattedMessage } from 'react-intl';

import './ProcessActions.css';

export default function ProcessActions() {
	const { retry, startNewAnalysis, status } = useProcessActions();

	if (status !== 'completed' && status !== 'error') {
		return null;
	}

	return (
		<div id="process-actions">
			<div className={`action-wrapper ${status === 'error' ? 'error-state' : 'success-state'}`}>
				<button onClick={startNewAnalysis} className="button new-button">
					<span className="icon icon-response" />
					<span>
						<FormattedMessage id="sentinel.process.new-analysis" />
					</span>
				</button>
				{status === 'error' && (
					<button onClick={retry} className="button retry-button">
						<span className="icon icon-radar" />
						<span>
							<FormattedMessage id="sentinel.process.retry" />
						</span>
					</button>
				)}
			</div>
		</div>
	);
}
